import React, { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import api from "../../Axios";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

const AddUserDetails = () => {
  const history = useHistory();

  const [formData, setFormData] = useState({
    education: "",
    employedIn: "",
    occupation: "",
    monthlyIncome: "",
    workLocation: "",
  });

  const educationOptions = {
    "Bachelor : Engineering / Computer Science": [
      "Aeronautical Engineering",
      "B.Arch",
      "BCA",
      "B.E",
      "B.Plan",
      "B.Sc. IT/CS",
      "B.S. Eng",
      "B.Tech",
      "Other",
    ],
    "Master : Engineering / Computer Science": [
      "M.Arch",
      "MCA",
      "M.E",
      "M.Sc. IT/CS",
      "M.S. Eng",
      "M.Tech",
      "PGDCA",
      "Other",
    ],
    "Bachelor : Arts / Science / Commerce": [
      "Aviation Degree",
      "B.A",
      "B.Com",
      "B.Ed",
      "BFA",
      "BFT",
      "BLIS",
      "B.M.M",
      "B.Sc",
      "B.S.W",
      "B.Phill",
      "Others",
    ],
    "Master : Arts / Science / Commerce": [
      "M.A",
      "M.Com",
      "M.Ed",
      "MFA",
      "MLIS",
      "M.Sc",
      "M.S.W",
      "M.Phil",
      "Other",
    ],
    "Bachelor : Management": ["BBA", "BFM", "BHM", "BHA"],
    "Master : Management": ["MBA", "MFM", "MHM", "MHRM", "PGDM", "MHA", "Other"],
    "Bachelor : Medicine - General / Dental / Surgeon": [
      "BAMS",
      "BDS",
      "BHMS",
      "BSMS",
      "BUMS",
      "BVSc",
      "MBBS",
    ],
    "Master : Medicine - General / Dental / Surgeon": [
      "MDS",
      "MD - Doctor of Medicine",
      "MS - Master of Surgery",
      "MVSc",
      "MCh",
      "DNB",
    ],
    "Bachelor : Pharmacy / Nursing": ["BPharm", "BPT", "B.Sc Nursing", "Other"],
    "Master : Pharmacy / Nursing": ["MPharm", "MPT", "Other"],
    "Bachelor : Legal": ["BGL", "BL", "LLB", "Other"],
    "Master : Legal": ["LLM", "ML", "Other"],
    "Finance - ICWAI / CA / CS / CFA": ["CA", "CFA", "CS", "ICWA", "Other"],
    "Civil Services": ["IAS", "IPS", "IRS", "IES", "IFS", "Other"],
    "Doctorates": ["Ph.D", "DM - Doctor of Medicine", "Postdoctoral Fellow", "FNB"],
    "Diploma": ["Diploma", "Polytechnic", "Other Diplomas"],
    "Higher Secondary": ["Higher Secondary School"],
    "Others": ["Other"],
  };


  const occupationByDepartment = {
    'Administration': [
      'Administration',
      'Manager',
      'Supervisor',
      'Office staff',
      'Administrative professional',
      'Executive',
      'Clerk',
      'HR - Human resources professional',
      'Secretary',
    ],
    'Agriculture': [
      'Agriculture & farming professional',
      'Horticulturist',
    ],
    'Airline': [
      'Pilot',
      'Air Hostess',
      'Flight Attendants',
      'Airline Professional',
    ],
    'Architecture & Design': [
      'Architect',
      'Interior Designer',
    ],
    'Banking & Finance': [
      'Chartered accountant',
      'Company Secretary',
      'Accounts',
      'Finance Professional',
      'Banking Professional',
      'Auditor',
      'Financial Accountant',
      'Financial Analyst & Planning',
      'Investment Professional',
    ],
    'Beauty & Fashion': [
      'Fashion designer',
      'Beautician',
      'Hair Stylist',
      'Jewellery Designer',
      'Designer (other)',
    ],
    'BPO & Customer service': [
      'BPO / KPO / ITES Professional',
      'Customer service Professional',
      'Telecaller',
    ],
    'Civil Services': [
      'IAS',
      'IPS',
      'IRS',
      'IFS',
      'Civil Services',
    ],
    'Corporate Professionals': [
      'Analyst',
      'Consultant',
      'Corporate Communication',
      'Corporate Planning',
      'Marketing Professional',
      'Operations Management',
      'Sales Professional',
      'Senior Manager / Manager',
      'Subject Matter Export',
      'Business Development Professional',
      'Content Writer',
    ],
    'Defense': [
      'Army',
      'Navy',
      'Defence Services',
      'Air Force',
      'Paramilitary',
    ],
    'Education & Training': [
      'Professor',
      'Lecturer',
      'Teaching / Academicians',
      'Education Professional',
      'Training Professional',
      'Research Assistant',
      'Research Scholar',
      'Teacher',
    ],
    'Engineering': [
      'Civil Engineer',
      'Electronic / Telecom Engineer',
      'Mechanical Engineer',
      'Production Engineer',
      'Quality Assurance Engineer',
      'Engineer - Non IT',
      'Designing Engineer',
      'Product Manager - Non IT',
      'Project Manager - Non IT',
    ],
    'Hospitality': [
      'Hospitality Professional',
    ],
    'IT & Software': [
      'Software Professional',
      'Software Engineer',
      'Hardware Professional',
      'Produced Manager - IT',
      'Project Manager - IT',
      'Program Manager - IT',
      'Animator',
      'Cyber / Network Security',
      'UI / UX Designer',
      'Web / Graphic Designer',
      'Software Consultant',
      'Data Analyst',
      'Data Scientist',
      'Network Engineer',
      'Quality Assurance Engineer',
    ],
    'Legal': [
      'Legal Professional',
      'Advocate',
      'Lawyer',
      'Legal assistant',
    ],
    'Police & Law Enforcement': [
      'Law Enforcement Officer',
      'Police',
    ],
    'Medical & Healthcare': [
      'Healthcare Professional',
      'Paramedical Professional',
      'Nurse',
      'Pharmacist',
      'Physiotherapist',
      'Therapist',
      'Medical Transcriptions',
      'Dietician / Nutritionist',
      'Lab Technician',
      'Medical Representative',
    ],
    'Media / Entertainment': [
      'Journalist',
      'Media Professional',
      'Entertainment Professional',
      'Event Management Professional',
      'Advertising / PR Professional',
      'Designer',
      'Actor / Model',
      'Artist',
    ],
    'Merchant Navy': [
      'Mariner / Merchant Navy',
      'Soilor',
    ],
    'Scientist': [
      'Scientist / Researcher',
    ],
    'Senior Management': [
      'CXO',
      'President',
      'Director',
      'Chairman',
      'VP',
      'AVP',
      'GM',
      'DGM',
      'AGM',
    ],
    'Others': [
      'Technician',
      'Arts & Craftsman',
      'Student',
      'Librarian',
      'Business Owner',
      'Business Partner',
      'Company Employee',
      'Retired',
      'Transportation / Logistics Professional',
      'Agent',
      'Broker',
      'Trader',
      'Contractor',
      'Coach',
      'Fitness Professional',
      'Fireman',
      'Security Professional',
      'Sociol Worker',
      'Volunteer',
      'NGO',
      'Sportsperson',
      'Travel Professional',
      'Singer',
      'Writer',
      'Politician',
      'Associate',
      'Construction Worker',
      'Chemist',
      'CNC Operator',
      'Distributor',
      'Driver',
      'Freelancer',
      'Manufacturer',
      'Mechanic',
      'Musician',
      'Photo / Videographer',
      'Post office',
      'Surveyor',
      'Tailor',
      'Cracker maker',
      'Municipality worker',
      'Tourist guide',
      'Typist',
      'Railway',
      'Wireman',
      'Zoologist',
      'Other',
    ],
    'Doctor': [
      'Doctor',
      'Dentist',
      'Surgeon',
      'Veterinary Doctor',
    ],
  };


  const employedInList = [
    "Private",
    "Government",
    "Business",
    "Self Employed",
    "Student",
    "Not Working",
  ];
  const monthlyIncomeList = [
    '15000 below',
    ...Array.from({ length: Math.floor((200000 - 15000) / 5000) }, (_, i) => {
      const start = 15000 + i * 5000;
      const end = start + 5000;
      return `₹${start} - ₹${end}`;
    }),
    '200000 above',
  ];

  console.log(monthlyIncomeList);

  const workLocationList = ["Erode", "Chennai", "Bangalore", "Abroad", "Other"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  let { id } = useParams();
  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      userId: id,
      education: formData.education,
      employedIn: formData.employedIn.toLowerCase().replace(/\s/g, ""),
      occupation: formData.occupation,
      monthlyIncome: formData.monthlyIncome,
      workLocation: formData.workLocation,
    };

    api
      .post("/admin/userProfile/userEducation/", payload)
      .then((res) => {
        Swal.fire("Success", "User details submitted successfully", "success");
        history.push(`/addkulam/${id}`);
      })
      .catch((err) => {
        Swal.fire("Error", err.message || "Something went wrong", "error");
      });
  };

  // Shared Styles
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    borderRadius: 12,
    border: "1.5px solid #757575",
    outline: "none",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 20,
    textTransform: "capitalize",
  };

  const labelStyle = {
    fontWeight: 800,
    marginBottom: 8,
    display: "block",
    color: "#212121",
  };

  const headingStyle = {
    color: "#1a237e",
    fontWeight: "900",
    padding: "20px 10px",
    fontSize: "1.8rem",
  };

  return (
    <Form
      onSubmit={handleSubmit}
      style={{ maxWidth: 1200, margin: "80px 20px" }}
    >
      <div style={headingStyle}>
        <h4>Professional Details</h4>
      </div>

      {/* Education */}
      <FormGroup>
        <Label htmlFor="education" style={labelStyle}>
          Educational Qualification
        </Label>
        <Input
          type="select"
          name="education"
          id="education"
          value={formData.education}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="">Select Education</option>
          {Object.entries(educationOptions).map(([group, options]) => (
            <optgroup label={group} key={group}>
              {options.map((edu) => (
                <option key={edu} value={edu}>
                  {edu}
                </option>
              ))}
            </optgroup>
          ))}
        </Input>
      </FormGroup>

      {/* Employed In */}
      <FormGroup>
        <Label htmlFor="employedIn" style={labelStyle}>
          Employed In
        </Label>
        <Input
          type="select"
          name="employedIn"
          id="employedIn"
          value={formData.employedIn}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="">Select Employment Type</option>
          {employedInList.map((emp) => (
            <option key={emp} value={emp}>
              {emp}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Occupation */}
      <FormGroup>
        <Label htmlFor="occupation" style={labelStyle}>
          Occupation
        </Label>
        <Input
          type="select"
          name="occupation"
          id="occupation"
          value={formData.occupation}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="">Select Occupation</option>
          {Object.entries(occupationByDepartment).map(([dept, list]) => (
            <optgroup key={dept} label={dept}>
              {list.map((job) => (
                <option key={job} value={job}>
                  {job}
                </option>
              ))}
            </optgroup>
          ))}
        </Input>
      </FormGroup>

      {/* Monthly Income */}
      <FormGroup>
        <Label htmlFor="monthlyIncome" style={labelStyle}>
          Monthly Income
        </Label>
        <Input
          type="select"
          name="monthlyIncome"
          id="monthlyIncome"
          value={formData.monthlyIncome}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="">Select Monthly Income</option>
          {monthlyIncomeList.map((amt) => (
            <option key={amt} value={amt}>
              {amt}
            </option>
          ))}
        </Input>
      </FormGroup>

      {/* Work Location */}
      {/* <FormGroup>
        <Label htmlFor="workLocation" style={labelStyle}>
          Work Location
        </Label>
        <Input
          type="select"
          name="workLocation"
          id="workLocation"
          value={formData.workLocation}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="">Select Work Location</option>
          {workLocationList.map((loc) => (
            <option key={loc} value={loc}>
              {loc}
            </option>
          ))}
        </Input>
      </FormGroup> */}

      <FormGroup>
        <Label htmlFor="workLocation" style={labelStyle}>
          Work Location
        </Label>
        <Input
          type="text"
          name="workLocation"
          id="workLocation"
          placeholder="Enter Work Location"
          value={formData.workLocation}
          onChange={handleChange}
          style={inputStyle}
        />
      </FormGroup>


      <Button
        type="submit"
        style={{
          width: "30%",
          borderRadius: 8,
          backgroundColor: "#000",
          color: "#fff",
          fontWeight: "bold",
          padding: "10px 0",
        }}
      >
        Submit & Continue
      </Button>
    </Form>
  );
};

export default AddUserDetails;
